import React from 'react'
import Volenter from './Volenter'

const GetInvolved = () => {
  return (
    <div className='md:py-24 py-12'>
        <Volenter/>
      
    </div>
  )
}

export default GetInvolved
